import { Box, styled, Typography } from '@mui/material';
import { AuthenticatedElement } from 'ogp/components/common/authenticated-element';
import { useGetOGPUserInfo } from 'ogp/hooks';
import { PolicyGroups } from 'shared/utils/policy-controller';
import { CompanyRole } from '@types';
import { useSidebarProvider } from 'shared/contexts/sidebar-provider';

const CompanyName = () => {
  const { isSidebarOpen } = useSidebarProvider();
  const { data: user } = useGetOGPUserInfo();

  return isSidebarOpen ? (
    <AuthenticatedElement roles={[CompanyRole.HQADMIN]} policyGroup={PolicyGroups.COMPANY}>
      <StyledCompanyInfoBox>
        <StyledCompanyName variant="body1">{user?.userInfo.company.name}</StyledCompanyName>
      </StyledCompanyInfoBox>
    </AuthenticatedElement>
  ) : null;
};

const StyledCompanyInfoBox = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  textOverflow: 'ellipsis',
  textAlign: 'center',
}));

const StyledCompanyName = styled(Typography)(() => ({
  overflow: 'hidden',
}));

export { CompanyName };
